// Sticky Add to Cart Button - Optimized
class StickyAddToCart {
  constructor() {
    if (window.innerWidth > 768) return;
    this.quantity = 1;
    this.originalText = this.getTranslation('add');
    this.addedText = this.getTranslation('added');
    this.notifyText = this.getTranslation('notify');
    this.init();
  }

  getTranslation(key) {
    const lang = document.documentElement.lang || 'en';
    const translations = {
      add: lang.startsWith('fr') ? 'Ajouter au panier' : 'Add to cart',
      added: lang.startsWith('fr') ? 'Ajouté !' : 'Added!',
      notify: lang.startsWith('fr') ? 'ME NOTIFIER' : 'NOTIFY ME'
    };
    return translations[key];
  }

  init() {
    this.setupScrollListener();
    this.setupSatisfactionBadge();
    this.setupPriceObserver();
  }

  changeQuantity(change) {
    this.quantity = Math.max(1, this.quantity + change);
    const quantityEl = document.getElementById('stickyQuantity');
    if (quantityEl) quantityEl.textContent = this.quantity;
    
    const mainInput = document.querySelector('input[name="quantity"]');
    if (mainInput) mainInput.value = this.quantity;
  }

  addToCart() {
    const button = document.getElementById('stickyAddButton');
    const buttonText = document.getElementById('buttonText');
    if (!button || !buttonText) return;
    
    if (button.classList.contains('notify-mode')) {
      this.openNotifyPopup();
      return;
    }
    
    const mainInput = document.querySelector('input[name="quantity"]');
    if (mainInput) mainInput.value = this.quantity;
    
    button.disabled = true;
    button.style.opacity = '0.7';
    
    const mainAddButton = document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    if (mainAddButton) {
      mainAddButton.click();
      setTimeout(() => {
        buttonText.textContent = this.addedText;
        setTimeout(() => {
          button.disabled = false;
          button.style.opacity = '1';
          buttonText.textContent = this.originalText;
        }, 2000);
      }, 500);
    }
  }

  setupSatisfactionBadge() {
    setTimeout(() => {
      const ratingEl = document.querySelector('.jdgm-prev-badge__stars');
      if (!ratingEl) return;
      
      const rating = parseFloat(ratingEl.getAttribute('data-score'));
      if (!rating) return;
      
      const percentage = Math.round((rating / 5) * 100);
      if (percentage >= 90) {
        const satisfactionEl = document.getElementById('stickySatisfaction');
        const percentEl = document.getElementById('stickySatisfactionPercent');
        if (satisfactionEl && percentEl) {
          percentEl.textContent = percentage;
          satisfactionEl.style.display = 'flex';
        }
      }
    }, 1500);
  }

  stripCurrency(text) {
    return text.replace(/\b[A-Z]{3}\b/g, '').trim();
  }

  updatePrice() {
    const priceContainer = document.querySelector('.price');
    if (!priceContainer) return;

    const stickyPrice = document.getElementById('stickyPrice');
    const stickyComparePrice = document.getElementById('stickyComparePrice');

    const isOnSale = priceContainer.classList.contains('price--on-sale');

    if (isOnSale) {
      const salePriceEl = priceContainer.querySelector('.price__sale .price-item--sale');
      const regularPriceEl = priceContainer.querySelector('.price__sale .price-item--regular');

      if (salePriceEl && stickyPrice) {
        stickyPrice.textContent = salePriceEl.textContent.trim();
      }
      if (regularPriceEl && stickyComparePrice) {
        stickyComparePrice.textContent = this.stripCurrency(regularPriceEl.textContent);
        stickyComparePrice.style.display = 'inline';
      }
    } else {
      const regularPriceEl = priceContainer.querySelector('.price__regular .price-item--regular');
      if (regularPriceEl && stickyPrice) {
        stickyPrice.textContent = regularPriceEl.textContent.trim();
      }
      if (stickyComparePrice) {
        stickyComparePrice.style.display = 'none';
      }
    }
  }

  updateAvailability() {
    const mainButton = document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    const stickyButton = document.getElementById('stickyAddButton');
    const buttonText = document.getElementById('buttonText');
    const quantitySelector = document.querySelector('.quantity-selector-sticky');
    
    if (!mainButton || !stickyButton || !buttonText) return;
    
    const isSoldOut = mainButton.disabled || 
                      mainButton.querySelector('span')?.textContent.toLowerCase().includes('épuisé') ||
                      mainButton.querySelector('span')?.textContent.toLowerCase().includes('sold out') ||
                      document.querySelector('.product-form__submit[disabled]');
    
    if (isSoldOut) {
      buttonText.textContent = this.notifyText;
      stickyButton.disabled = false;
      stickyButton.classList.add('notify-mode');
      stickyButton.style.opacity = '1';
      if (quantitySelector) quantitySelector.style.display = 'none';
    } else {
      buttonText.textContent = this.originalText;
      stickyButton.disabled = false;
      stickyButton.classList.remove('notify-mode');
      if (quantitySelector) quantitySelector.style.display = 'flex';
    }
  }

  openNotifyPopup() {
    const buttons = Array.from(document.querySelectorAll('button'));
    const notifyBtn = buttons.find(btn => {
      const text = btn.textContent.trim();
      const isNotifyButton = (text === 'Me notifier' || text === 'Notify me');
      const notSticky = !btn.closest('#stickyAddToCart');
      return isNotifyButton && notSticky;
    });
    
    if (notifyBtn) {
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
        detail: 1
      });
      notifyBtn.dispatchEvent(clickEvent);
      setTimeout(() => notifyBtn.click(), 100);
    }
  }

  setupPriceObserver() {
    setTimeout(() => {
      this.updatePrice();
      this.updateAvailability();
    }, 500);
    
    this.priceCheckInterval = setInterval(() => {
      this.updatePrice();
      this.updateAvailability();
    }, 500);
    
    document.addEventListener('click', (e) => {
      if (e.target.closest('variant-radios') || e.target.closest('variant-selects') || e.target.closest('fieldset')) {
        setTimeout(() => {
          this.updatePrice();
          this.updateAvailability();
        }, 300);
      }
    });
  }

  setupScrollListener() {
    const stickyButton = document.getElementById('stickyAddToCart');
    const originalButton = document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    if (!stickyButton || !originalButton) return;

    let originalVisible = false;
    let footerVisible = false;

    const update = () => {
      const menuOpen =
        document.querySelector('details.menu-opening[open]') ||
        document.querySelector('.menu-drawer.active');

      stickyButton.style.display =
        (originalVisible || footerVisible || menuOpen) ? 'none' : 'block';
    };

    const originalObserver = new IntersectionObserver(
      ([entry]) => {
        originalVisible = entry.isIntersecting;
        update();
      },
      { threshold: 0.01 }
    );
    originalObserver.observe(originalButton);

    const footer = document.querySelector('footer.footer');
    if (footer) {
      const footerObserver = new IntersectionObserver(
        ([entry]) => {
          footerVisible = entry.isIntersecting;
          update();
        },
        { threshold: 0.01 }
      );
      footerObserver.observe(footer);
    }
  }
}

window.changeQuantitySticky = function(change) {
  if (window.stickyCart) window.stickyCart.changeQuantity(change);
};

window.addToCartSticky = function() {
  if (window.stickyCart) window.stickyCart.addToCart();
};

function initStickyCart() {
  if (document.getElementById('stickyAddToCart')) {
    window.stickyCart = new StickyAddToCart();
  } else {
    setTimeout(initStickyCart, 300);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyCart);
} else {
  initStickyCart();
}